import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';

export default function Home() {
  const siteName = '韩漫之家';
  const description = '在韩漫之家发现精彩好看韩国漫画，享受韩漫在线无删减下拉式免费阅读，提供完整而可靠的阅读服务。';
  const keywords = '好看韩国漫画, 韩漫在线, 无删减下拉式, 韩漫免费阅读, 韩漫之家';
  const canonicalUrl = typeof window !== 'undefined' ? window.location.origin + '/' : '';

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteName,
    url: canonicalUrl,
    description: description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${canonicalUrl}/category/all?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteName,
    url: canonicalUrl,
    description: description,
    sameAs: [],
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteName} - ${description.substring(0, 50)}`,
    description: description,
    url: canonicalUrl,
  };

  return (
    <>
      <SEO
        title={`${siteName}_好看韩国漫画_韩漫在线_无删减下拉式韩漫免费阅读`}
        description={description}
        keywords={keywords}
        canonicalUrl={canonicalUrl}
        schemaJson={{ ...orgSchema, ...webSiteSchema, ...webPageSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategoryNav />
          <LatestUpdates />
          <RankingSection />
        </main>
        <Footer />
      </div>
    </>
  );
}